import { useCallback, useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useDispatch, useSelector } from "react-redux";
import { ModificarMoverEvento, obtenerListaEventos, obtenerListaSalones } from "../../../store/Calendario/thunkCalendario";
import CircularProgress from "@mui/material/CircularProgress"; // Usamos el componente CircularProgress para el preload
import Swal from "sweetalert2";
import { ModalMostrarInfo } from "./ModalMostrarInfo";
import { setAgregarFecha, setModificarEvento, setPreload } from "../../../store/Eventos/eventoSlice";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";


export const CalendarioFull = ({ colorHeader, Salones }) => {
    const { id_admin, name_admin } = useSelector((state) => state.auth);
    const location = useLocation();
    // Estado para manejar la apertura y cierre del modal de creación de eventos.
    const [openModal, setopenModal] = useState(false); // Correcto, ya está en false inicialmente.

    const handleOpenModal = () => setopenModal(true); // Solo cambia a true.
    const handleCloseModal = () => setopenModal(false); // Solo cambia a false.

    // Estado para almacenar los datos del evento seleccionado.
    const [datosEvento, setDatosEvento] = useState({}); // Estado para almacenar los datos del evento seleccionado.

    // Estado para almacenar los recursos del calendario (salones).
    const [resources, setResources] = useState([]);

    // Estado para manejar la carga (true mientras se cargan los datos).
    const [loading, setLoading] = useState(true);

    // Hook de Redux para despachar acciones.
    const dispatch = useDispatch();

    // Estado para almacenar los eventos del calendario.
    const [events, setEvents] = useState([]);

    const { eventosSeleccionados, fechaBuscar, hotel } = useSelector((state) => state.evento);

    // Este useEffect se ejecuta una sola vez al montar el componente.

    const getQueryParam = (param) => {
        // Crea una instancia de 'URLSearchParams' con los parámetros de la URL.
        const params = new URLSearchParams(window.location.search);
        const value = params.get(param);

        // Retorna el valor como número si es numérico, o como cadena si no lo es.
        if (value !== null && !isNaN(value) && !isNaN(parseFloat(value))) {
            return Number(value);
        }
        return value; // Retorna null o el valor original como cadena.
    };
    // Su propósito es recuperar los parámetros de consulta y establecer un estado inicial utilizando el dispatch.

    useEffect(() => {
        // Recupera el parámetro 'data' (fecha del evento) de la URL.
        const eventoDate = getQueryParam("datalook");

        // Recupera el parámetro 'data2' (filtro de hotel) de la URL.
        // Si no está presente, utiliza un valor por defecto (variable 'hotel').
        const hotelFilte = getQueryParam("data2");
        const hotelFilter = hotelFilte || hotel; // Usa operador lógico para simplificar.

        // Si existe un valor para 'eventoDate', actualiza el estado global.
        if (eventoDate) {
            dispatch(
                setPreload({
                    fechaBuscar: eventoDate, // Establece la fecha a buscar.
                    hotel: hotelFilter, // Establece el filtro del hotel.
                }),
            );
        } else {
             dispatch(
                 setPreload({
                     fechaBuscar: startDate, // Establece la fecha a buscar.
                     hotel: 1, // Establece el filtro del hotel.
                 }),
             );
        }
    }, []);
    // Estado para la referencia del calendario.
    const [calendarRef, setCalendarRef] = useState(null);

    // Obtener la fecha de hoy en formato 'YYYY-MM-DD'.
    const today = new Date();
    const startDate = today.toISOString().split("T")[0];

    // Calcular la fecha de 4 años después y convertir a formato 'YYYY-MM-DD'.
    const endDate = new Date();
    endDate.setFullYear(today.getFullYear() + 4);
    const endDateFormatted = endDate.toISOString().split("T")[0];

    // Inicializar los valores de rango de fechas con las fechas calculadas.
    const [startValue, setStartValue] = useState(startDate);
    const [endValue, setEndValue] = useState(endDateFormatted);

    /**
     * Función para actualizar la lista de eventos combinando eventos previos con eventos seleccionados.
     * Esta función asegura que se mantengan los eventos relevantes y actualiza correctamente los nuevos y existentes.
     *
     * @param {Array} eventosPrevios - Lista de eventos actuales antes de la actualización.
     * @param {Array} eventosSeleccionados - Lista de eventos seleccionados para combinar con los existentes.
     * @returns {Array} Lista actualizada de eventos, combinando los anteriores con los nuevos seleccionados.
     */
    const actualizarEventos = (eventosPrevios, eventosSeleccionados) => {
        // Si no hay eventos seleccionados, elimina los eventos con idTemporal (temporales).
        if (!eventosSeleccionados || eventosSeleccionados.length === 0) {
            return eventosPrevios.filter((evento) => !evento.idTemporal);
        }

        // Crear un conjunto de IDs de los eventos seleccionados para facilitar las búsquedas.
        const idsSeleccionados = new Set(eventosSeleccionados.map((evento) => evento._id || evento.idTemporal));

        /**
         * Filtrar eventosPrevios:
         * - Mantener eventos que no son temporales.
         * - Mantener eventos temporales que están en eventosSeleccionados.
         */
        const eventosActualizados = eventosPrevios.filter((evento) => {
            const id = evento._id || evento.idTemporal; // Obtener identificador único.
            return !evento.idTemporal || idsSeleccionados.has(id); // Validar si el evento es relevante.
        });

        // Crear un conjunto de IDs de los eventos ya presentes en la lista actualizada.
        const idsExistentes = new Set(eventosActualizados.map((evento) => evento._id || evento.idTemporal));

        /**
         * Identificar nuevos eventos para agregar:
         * - Seleccionar eventos en eventosSeleccionados que no están en la lista actualizada.
         */
        const nuevosEventos = eventosSeleccionados.filter((evento) => {
            const id = evento._id || evento.idTemporal; // Obtener identificador único.
            return !idsExistentes.has(id); // Agregar solo si no existe ya en la lista actualizada.
        });

        // Combinar eventos actualizados con los nuevos para obtener la lista final.
        return [...eventosActualizados, ...nuevosEventos];
    };

    

    /**
     * Función asíncrona para obtener y procesar datos de salones y eventos.
     * Utiliza acciones de Redux para despachar solicitudes y actualizar el estado local.
     *
     * @param {Array} SalonesId - Identificadores de los salones a buscar.
     * @param {string} startValue - Fecha de inicio del rango para obtener eventos.
     * @param {string} endValue - Fecha de finalización del rango para obtener eventos.
     * @param {Array} eventosSeleccionados - Lista de eventos seleccionados previamente.
     */
    const fetchSalones = useCallback(
        async (SalonesId, startValue, endValue, eventosSeleccionados) => {
            // Inicia el estado de carga y limpia los recursos existentes.
            setLoading(true); // Indica que se está cargando información.
            setResources([]); // Resetea la lista de recursos.

            const hotelFilte = getQueryParam("data2");

            const hotelFilter = hotelFilte || SalonesId; // Usa operador lógico para simplificar.

            // Despacha una acción para obtener la lista de salones desde el backend.
            const response = await dispatch(obtenerListaSalones(hotelFilter));

            /**
             * Formatea los datos de salones para adaptarlos al formato esperado por el calendario.
             * Cada recurso representa un salón con su ID, nombre y hotel asociado.
             */
            const formattedResources = response.map((item) => ({
                id: item.id_salon, // Identificador único del salón.
                title: item.nombre_salon, // Nombre del salón.
                hotel: item.id_hotel, // Identificador del hotel asociado.
            }));

            // Ordena los recursos alfabéticamente por el título (nombre del salón)
            formattedResources.sort((a, b) => a.id - b.id);
                
            
            setResources(formattedResources); // Actualiza el estado local de recursos con los datos formateados y ordenados.

            const eventoDate = getQueryParam("datalook");

            const startEventFilter = eventoDate ? eventoDate : startValue;
            const endEventFilter = eventoDate ? eventoDate : endValue;

            if (eventoDate) {
                setStartValue(startEventFilter);
                if (calendarRef) {
                    calendarRef.getApi().gotoDate(startEventFilter);
                }
            }

            // Despacha una acción para obtener la lista de eventos en el rango de fechas especificado.
            const responseEvents = await dispatch(obtenerListaEventos(SalonesId, startEventFilter, endEventFilter));

            /**
             * Mapea los eventos obtenidos a un formato adecuado para el calendario.
             * Este formato incluye información clave como título, fechas, colores y asociaciones con salones y usuarios.
             */
            const responseMaps = responseEvents.map((evento) => ({
                _id: evento.id_evento, // Identificador único del evento.
                nombresAdmins: evento.nombres_admins, // Nombres de los administradores asociados al evento.
                resourceId: evento.id_salon, // ID del salón asociado al evento.
                title: `Evento: ${evento.nombre_evento}, Ejecutivos: ${evento.nombres_admins}, ${evento.cantidad_evento} pax`,
                start: evento.fech_Inicio_evento, // Fecha de inicio del evento.
                end: evento.fech_final_evento, // Fecha de finalización del evento.
                color: evento.color_evento, // Color asignado al evento.
                user: evento.id_usuarios, // Identificador del usuario asociado al evento.
                estadoid: evento.estado_evento, // Estado actual del evento.
                salonid: evento.id_salon, // ID del salón.
                hotelid: evento.id_hotel, // ID del hotel.
                ids: evento.id_evento, // Alias para el identificador del evento.
                token: evento.id_referencia, // Token o referencia única asociada al evento.
                selectOverlap: true, // Permitir selección de eventos superpuestos.
                idTemporal: 0, // Indica que no es un evento temporal.
                temporal: false, // Marca de evento no temporal.
                temporalEditar: false, // Marca de evento no temporal editable.
            }));

            /**
             * Actualiza el estado de eventos combinando los eventos previos con los nuevos.
             * Primero, se inicializa la lista con `responseMaps`.
             * Luego, se asegura de integrar los eventos seleccionados evitando duplicados.
             */
            setEvents((eventosPrevios) => {
                const eventosIniciales = actualizarEventos(eventosPrevios, responseMaps);
                return actualizarEventos(eventosIniciales, eventosSeleccionados);
            });

            // Finaliza el estado de carga.
            setLoading(false);
        },
        [dispatch], // Dependencia de Redux para asegurar la consistencia.
    );

    /**
     * useEffect para obtener salones y eventos cuando cambien los parámetros relevantes.
     * Este efecto se ejecuta cada vez que `Salones`, `startValue`, `endValue`, o las dependencias cambian.
     */
    useEffect(() => {
        // Llama a la función `fetchSalones` con los valores actuales de salones y rango de fechas.
        // Esto asegura que la lista de salones y eventos esté actualizada con los parámetros actuales.
        fetchSalones(Salones, startValue, endValue, eventosSeleccionados);
    }, [Salones, startValue, endValue, dispatch, fetchSalones]);
    // Dependencias: asegura que el efecto se ejecute solo cuando cambien estos valores.

    /**
     * useEffect para sincronizar los eventos seleccionados con el estado local.
     * Este efecto se ejecuta cada vez que cambian los eventos seleccionados.
     */
    useEffect(() => {
        // Actualiza el estado de eventos combinando los eventos previos con los seleccionados.
        setEvents((eventosPrevios) => actualizarEventos(eventosPrevios, eventosSeleccionados));
    }, [eventosSeleccionados]);
    // Dependencia: se ejecuta solo cuando `eventosSeleccionados` cambia.

    useEffect(() => {
        /**
         * Formatea la fecha de búsqueda (`fechaBuscar`) para asegurarse de que
         * sólo contenga la parte de la fecha ("yyyy-MM-dd"), eliminando cualquier
         * información de hora si está presente.
         */
        const startDateFormatted = fechaBuscar.includes(" ")
            ? fechaBuscar.split(" ")[0] // Extrae solo la fecha antes del espacio.
            : fechaBuscar;

        // Actualiza los estados de inicio y fin con la fecha formateada.
        setStartValue(startDateFormatted);

        // Verifica que el `calendarRef` esté disponible y que `fechaBuscar` no sea nulo o vacío.
        if (calendarRef && fechaBuscar) {
            /**
             * Usa un `setTimeout` para ejecutar el código después del ciclo de renderización actual.
             * Esto evita conflictos con React, especialmente cuando se interactúa con referencias
             * o APIs de terceros como FullCalendar.
             */
            setTimeout(() => {
                // Si el hotel actual es diferente del `hotelGlobal`, actualiza los salones y sincroniza el estado global.
                fetchSalones(hotel, fechaBuscar, endValue, eventosSeleccionados);

                // Navega a la fecha proporcionada en el calendario.
                calendarRef.getApi().gotoDate(fechaBuscar);
            }, 0);
        }
    }, [fechaBuscar, calendarRef, hotel, dispatch, fetchSalones]); // Lista de dependencias garantiza que el efecto se ejecute correctamente.

    // *****************************************

    // useEffect para actualizar el estilo del encabezado del calendario dinámicamente.
    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
      .fc-col-header-cell {
        background-color: ${colorHeader} !important;
        color: #ffffff !important;
      }
    `;
        document.head.appendChild(style);

        // Limpia el estilo cuando el componente se desmonte o cambie el color del encabezado.
        return () => {
            document.head.removeChild(style);
        };
    }, [colorHeader]);

    /**
     * Maneja el cambio de la fecha seleccionada en el calendario.
     *
     * @param {Object} event - Evento generado por el selector de fechas.
     */
    const handleDateChange = (event) => {
        const selectedDate = event.target.value;

        // Actualiza el rango de fechas con la fecha seleccionada.
        setStartValue(selectedDate);
        setEndValue(selectedDate);


        const eventoDate = getQueryParam("datalook");


        if (eventoDate) {
             window.location.href = `/calendario/ver?datalook=${selectedDate}&data2=${hotel}`;
        }

        // Mueve el calendario a la fecha seleccionada si la referencia está disponible.
        if (calendarRef) {
            calendarRef.getApi().gotoDate(selectedDate);
        }
    };

    /**
     * Formatea un objeto Date en una cadena con el formato 'YYYY-MM-DD HH:mm'.
     *
     * @param {Date} date - Objeto Date que se desea formatear.
     * @returns {string} Fecha y hora formateada como 'YYYY-MM-DD HH:mm'.
     */
    const formatDate = (date) => {
        // Obtiene el año completo (YYYY).
        const year = date.getFullYear();

        // Obtiene el mes (0-11) y lo ajusta a (1-12), luego lo convierte a un formato de dos dígitos.
        const month = String(date.getMonth() + 1).padStart(2, "0");

        // Obtiene el día del mes (1-31) y lo convierte a un formato de dos dígitos.
        const day = String(date.getDate()).padStart(2, "0");

        // Obtiene la hora (0-23) y la convierte a un formato de dos dígitos.
        const hours = String(date.getHours()).padStart(2, "0");

        // Obtiene los minutos (0-59) y los convierte a un formato de dos dígitos.
        const minutes = String(date.getMinutes()).padStart(2, "0");

        // Combina todos los valores en el formato 'YYYY-MM-DD HH:mm'.
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    /**
     * Función para manejar el cambio de fechas o recursos de un evento en el calendario.
     * Diferencia entre eventos temporales y permanentes, aplicando lógica adecuada a cada caso.
     *
     * @param {Object} info - Información del evento proporcionada por la biblioteca de calendario.
     */
    const ModificarFechasEvento = (info) => {
        let temporal = info.event._def.extendedProps.temporal;
        if (!temporal) {
            const user = info.event._def.extendedProps.user;
            const nombresAdmins = info.event._def.extendedProps.nombresAdmins;

            // Extraer solo los números de la cadena
            const cleanedNumbers = user.match(/\d+/g).join(","); // Ejemplo: "90,91"

            // Convertir cleanedNumbers en un array para buscar dentro
            const permisos = cleanedNumbers.split(",").map(Number); // ['90', '91'] -> [90, 91]

            // Validar si el id del admin está en los permisos
            if (!permisos.includes(id_admin)) {
                Swal.fire({
                    icon: "error",
                    title: `Lo sentimos ${name_admin}`,
                    html: `
                                    No puedes mover el evento seleccionado sin los permisos adecuados. 
                                    Por favor, contacta a los ejecutivos asignados para obtener la autorización necesaria.
                                    <br/><br/>
                                    Representantes asignados:
                                    <br/><br/><strong>${nombresAdmins}</strong>
                                `,
                    confirmButtonText: "Entendido",
                });
                info.revert();

                // Código adicional para el caso negativo
                return;
            }
        }

        // Extrae la información relevante del evento.
        const { start, end, extendedProps } = info.event;

        // Convierte las fechas de inicio y fin al formato estándar 'YYYY-MM-DD HH:mm:ss'.
        const eventStart = formatDate(new Date(start));
        const eventEnd = formatDate(new Date(end));

        // Determina el ID del recurso actualizado (nuevo o existente).
        const resourceId = info.newResource?.id ? parseInt(info.newResource.id, 10) : parseInt(info.oldEvent?._def?.resourceIds?.[0] || "0", 10);

        /**
         * Muestra una notificación de éxito al usuario.
         *
         * @param {string} mensaje - Mensaje a mostrar en la notificación.
         */
        const mostrarNotificacion = (mensaje) => {
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: mensaje,
                showConfirmButton: false,
                timer: 500,
                width: 600,
                padding: "1em",
            });
        };

        // Manejo de eventos temporales.
        if (extendedProps.temporal) {
            const ids = Math.floor(Math.random() * 9000000000) + 1000000000;
            const path = location.pathname.split("/");

            const salon_id = info.newResource?._resource?.id || info.event._def.resourceIds[0];
            const hotel_id = info.newResource?._resource?.extendedProps?.hotel || info.oldEvent?._def?.extendedProps?.hotelid;
            const oldId = info.oldEvent?._def?.extendedProps?.idTemporal || info.oldEvent?._def?.extendedProps._id;
            const nombreSalon = info.newResource?._resource?.title || info.oldEvent?._def?.extendedProps.nombreSalon;

            // Despachar acción con valores completos
            dispatch(
                setModificarEvento({
                    oldId: oldId,
                    idTemporal: ids,
                    _id: ids, // ID único del evento.
                    resourceId: resourceId, // ID del salón asociado.
                    title: "Evento #" + ids, // Nombre del evento.
                    start: eventStart, // Fecha de inicio.
                    end: eventEnd, // Fecha de finalización.
                    color: "#f4d03f", // Color del evento.
                    user: "users", // ID del usuario relacionado.
                    estadoid: ";", // Estado del evento.
                    salonid: salon_id, // ID del salón.
                    hotelid: hotel_id, // ID del hotel.
                    ids: ids, // Alias del identificador del evento.
                    token: "", // Token o referencia única.
                    selectOverlap: true, // Permite selección de eventos superpuestos.
                    temporal: true, // No es un evento temporal.
                    nombreSalon: nombreSalon, // Nombre del salón.
                    temporalEditar: path[1] === "evento" && path[2] === "crear" ? true : false, // esto solo aplica cuando voy a editar el event
                }),
            );

            // Notifica al usuario del éxito de la operación.
            mostrarNotificacion("El evento temporal fue movido con éxito");
            return; // Termina la ejecución ya que no se requiere más procesamiento.
        }

        // Manejo de eventos permanentes con confirmación del usuario.
        Swal.fire({
            title: "¿Estás seguro de mover este evento?",
            text: "Los cambios no se podrán deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, mover",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                // Si el usuario confirma, despacha la acción para actualizar el evento en el backend.
                dispatch(ModificarMoverEvento(extendedProps._id, eventStart, eventEnd, resourceId));
                // Notifica al usuario del éxito de la operación.
                mostrarNotificacion("El evento fue movido con éxito");
            } else {
                info.revert();
                // Si el usuario cancela, vuelve a cargar los salones y eventos originales.
                fetchSalones(Salones, startValue, endValue);
            }
        });
    };

    const navigate = useNavigate();
    const navegarCrearEvento = () => {
        navigate("/evento/crear");
    };


     const inactivityTimer = useRef(null);

    useEffect(() => {
        // Función para reiniciar el temporizador cuando hay actividad
        const resetInactivityTimer = () => {
            if (inactivityTimer.current) {
                clearTimeout(inactivityTimer.current);
            }

            // Establecer un nuevo temporizador de 6 segundos
            inactivityTimer.current = setTimeout(() => {
                // Mostrar SweetAlert para notificar inactividad
                Swal.fire({
                    title: "Inactividad detectada",
                    text: "Pasaste mucho tiempo inactivo y algunos eventos fueron agregados o editados. Vamos a actualizar el calendario por ti.",
                    icon: "info",
                    showCancelButton: true, // Habilitar el botón de Cancelar
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                    allowOutsideClick: false, // Evita que se cierre al hacer clic fuera
                    allowEscapeKey: false, // Evita que se cierre con la tecla Escape
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Recargar la página al presionar el botón "Aceptar"
                        window.location.reload();
                    } else if (result.isDismissed) {
                        // Acciones opcionales si se presiona "Cancelar"
                        console.log("El usuario canceló la recarga.");
                    }
                });
            }, 120000); // 20 segundos de inactividad
        };

        // Eventos a monitorear
        const activityEvents = ["mousemove", "keydown", "click", "scroll", "touchstart"];

        // Agregar los eventos de escucha
        activityEvents.forEach((event) => {
            window.addEventListener(event, resetInactivityTimer);
        });

        // Iniciar el temporizador al cargar el componente
        resetInactivityTimer();

        // Limpieza de los eventos y el temporizador al desmontar el componente
        return () => {
            activityEvents.forEach((event) => {
                window.removeEventListener(event, resetInactivityTimer);
            });
            if (inactivityTimer.current) {
                clearTimeout(inactivityTimer.current);
            }
        };
    }, []);

    return (
        <div style={{ position: "relative" }}>
            {/* Selector de fecha */}
            <div className="pc-component card-body">
                <div className="row">
                    <div className="col-md-4 mb-2" style={{ marginLeft: "auto" }}>
                        <label className="form-label" style={{ textAlign: "right", display: "block" }}>
                            Fecha de búsqueda:
                        </label>
                        <div className="d-flex justify-content-end">
                            <input
                                className="form-control"
                                type="date"
                                value={startValue}
                                onChange={handleDateChange}
                            />
                        </div>
                    </div>
                </div>
                <hr />
            </div>

            {/* Configuración del componente FullCalendar */}
            <FullCalendar
                schedulerLicenseKey="GPL-My-Project-Is-Open-Source" // Licencia GPL para proyectos de código abierto.
                plugins={[resourceTimeGridPlugin, interactionPlugin]} // Plugins para vista de cuadrícula y funcionalidad interactiva.
                initialView="resourceTimeGridDay" // Vista inicial: cuadrícula de recursos por día.
                initialDate={fechaBuscar} // Fecha inicial configurada aquí.
                resources={resources} // Lista de recursos (salones).
                events={events} // Lista de eventos para mostrar en el calendario.
                resourceOrder="title" // Add this line to sort resources by title
                headerToolbar={{
                    left: "prev,next today crearEvento", // Controles de navegación.
                    center: "title", // Título centrado.
                    right: "resourceTimeGridDay", // Incluye el botón personalizado.
                }}
                customButtons={{
                    crearEvento: {
                        text: "Crear Evento en Firme",
                        style: "background-color: #000; color: #fff; border: none; padding: 0.5rem 1rem; border-radius: 0.25rem; cursor: pointer;",
                        click: () => navegarCrearEvento(),
                        className: "btn btn-dark", // Vacío si los estilos inline se aplican.
                    },
                }}
                buttonText={{
                    style: "background-color: #000; color: #fff; border: none; padding: 0.5rem 1rem; border-radius: 0.25rem; cursor: pointer;",
                    crearEvento: "Crear Evento en Firme",
                    className: "btn btn-dark", // Vacío si los estilos inline se aplican.
                }}
                eventOverlap={false} // Previene la superposición de eventos.
                allDaySlot={false} // Oculta la sección de eventos de todo el día.
                slotMinTime="07:00:00" // La vista comienza a las 7:00 AM.
                slotMaxTime="23:00:00" // La vista termina a las 11:00 PM.
                slotDuration="00:30:00" // Cada ranura tiene 30 minutos de duración.
                scrollTime="08:00:00" // La vista comienza desplazada a las 8:00 AM.
                height="auto" // Ajusta automáticamente la altura según los eventos visibles.
                editable={true} // Permite arrastrar y redimensionar eventos.
                selectable={true}
                eventResizableFromStart={true} // Permite ajustar la hora de inicio de un evento.
                eventContent={(eventInfo) => {
                    // Configuración personalizada para mostrar el contenido de un evento.
                    return (
                        <div
                            style={{
                                whiteSpace: "normal", // Permite ajustar el texto en múltiples líneas.
                                wordWrap: "break-word", // Rompe las palabras largas.
                                fontSize: "clamp(0.5rem, 0.7vw, 12rem)", // Ajusta el tamaño del texto dinámicamente.
                                lineHeight: "1.1", // Espaciado entre líneas reducido.
                                textAlign: "top", // Texto alineado hacia arriba.
                                maxWidth: "100%", // Asegura que el contenido no exceda el contenedor.
                                overflow: "hidden", // Oculta contenido desbordado.
                                display: "flex", // Uso de flexbox para distribuir el contenido.
                                flexDirection: "column",
                                justifyContent: "top",
                                height: "100%",
                            }}
                        >
                            <b style={{ color: "red" }}>{eventInfo.timeText}</b> {/* Hora en texto rojo. */}
                            <br />
                            <span>{eventInfo.event.title}</span> {/* Título del evento. */}
                        </div>
                    );
                }}
                ref={setCalendarRef} // Referencia al calendario para manipularlo desde otros métodos.
                resourceLabelDidMount={(info) => {
                    // Estiliza el fondo del recurso (salón) con el color definido en las propiedades extendidas.
                    info.el.style.backgroundColor = info.resource.extendedProps.color;

                    // Cambia el color del texto a blanco para garantizar una buena visibilidad.
                    info.el.style.color = "#ffffff";
                }}
                eventDrop={(info) => {
                    // Maneja el evento de arrastrar y soltar para mover eventos.
                    ModificarFechasEvento(info);
                }}
                eventResize={(info) => {
                    // Maneja el evento de redimensionar para ajustar la duración de los eventos.
                    ModificarFechasEvento(info);
                }}
                eventClick={(info) => {
                    const { extendedProps } = info.event;
                    if (extendedProps.temporal) {
                       Swal.fire({
                           icon: "info",
                           title: "Eventos Temporales",
                           text: "Los eventos temporales no pueden ser editados directamente. ¿Deseas generar los eventos en firme?",
                           showCancelButton: true,
                           confirmButtonText: "Crear Evento en Firme",
                           cancelButtonText: "Cancelar",
                       }).then((result) => {
                           if (result.isConfirmed) {
                               navegarCrearEvento(); // Ejecuta la función para crear el evento en firme
                           }
                           // Si se cancela, no se necesita hacer nada adicional, el alert simplemente se cierra
                       });
                        return; // Finaliza la ejecución ya que no se necesita más procesamiento.
                    }
                    setDatosEvento(info); // Almacena los datos del evento seleccionado.
                    handleOpenModal(); // Abre el modal al hacer clic en un evento
                }}
                /**
                 * Manejo del evento de selección en el calendario.
                 * Este código se ejecuta cuando el usuario selecciona un rango en el calendario.
                 */
                select={(info) => {
                    // Extrae las fechas de inicio y fin del rango seleccionado.
                    const { start, end } = info;

                    // Convierte las fechas al formato estándar 'YYYY-MM-DD HH:mm:ss'.
                    const eventStart = formatDate(start);
                    const eventEnd = formatDate(end);

                    const ids = Math.floor(Math.random() * 9000000000) + 1000000000;

                    // Dividir la URL en partes
                    const path = location.pathname.split("/");

                    // Despacha la acción para agregar un nuevo evento temporal al estado.
                    dispatch(
                        setAgregarFecha({
                            idTemporal: ids, // ID temporal único generado aleatoriamente.
                            _id: ids, // ID único para identificar el evento.
                            resourceId: info.resource.id, // ID del recurso (salón) asociado al evento.
                            title: "Evento Temporal #" + ids, // Título genérico para el evento temporal.
                            start: eventStart, // Fecha de inicio formateada.
                            end: eventEnd, // Fecha de fin formateada.
                            color: "#f4d03f", // Color asignado al evento.
                            user: "usrTemporal", // ID del usuario asociado al evento.
                            estadoid: "activo", // Estado del evento (ejemplo: activo).
                            salonid: info.resource.id, // ID del salón asociado al evento.
                            hotelid: info.resource.extendedProps.hotel, // ID del hotel al que pertenece el salón.
                            ids: ids, // Identificador adicional único.
                            token: "abc123", // Token de referencia (puedes modificar según necesidad).
                            selectOverlap: true, // Permitir solapamiento con otros eventos seleccionados.
                            temporal: true, // Marca que indica que el evento es temporal.
                            nombreSalon: info.resource.title,
                            temporalEditar: path[1] === "evento" && path[2] === "crear" ? true : false, // esto solo aplica cuando voy a editar el evento
                        }),
                    );

                    // Aquí puedes agregar lógica adicional para manejar la selección, como notificaciones o validaciones.
                }}
                titleFormat={{
                    year: "numeric", // Año completo (e.g., 2023).
                    month: "long", // Nombre completo del mes (e.g., octubre).
                    day: "numeric", // Día del mes (e.g., 23).
                    weekday: "long", // Día de la semana (e.g., lunes).
                }}
                locale="es" // Configuración del idioma en español.
                slotLabelFormat={{
                    hour: "numeric", // Muestra la hora en formato numérico.
                    minute: "2-digit", // Incluye minutos con 2 dígitos.
                    hour12: true, // Muestra AM/PM en el formato de 12 horas.
                }}
                eventTimeFormat={{
                    hour: "numeric", // Formato de hora para eventos.
                    minute: "2-digit", // Incluye minutos.
                    hour12: true, // Formato de 12 horas con AM/PM.
                }}
                selectOverlap={(event) => {
                    // Define si se permite la superposición con eventos de fondo.
                    return event.rendering === "background";
                }}
            />

            {/* Loader Circular */}
            {loading && (
                <div
                    style={{
                        position: "absolute", // Cubre toda la pantalla.
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex", // Centra el contenido.
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999, // Asegura que esté por encima del calendario.
                        backgroundColor: "rgba(236, 240, 241 , 0.7)", // Fondo semitransparente.
                    }}
                >
                    <CircularProgress /> {/* Icono de carga circular */}
                </div>
            )}
            {openModal && (
                <ModalMostrarInfo open={openModal} handleClose={handleCloseModal} funciones={fetchSalones} type="lista" datas={datosEvento} />
            )}
        </div>
    );
};
